import React from 'react';
import { components } from 'react-select';

export const SelectInput = ({
    selectProps,
    ...props
}) => (
    <components.Input
        {...props}
        selectProps={selectProps}
        data-testid={selectProps?.testIds?.Input}
    />
);
